<template>
  <!-- Partners Section -->
  <div class="partners-section partner-section-eight">
    <div class="container">
      <div class="section-heading heading-eight">
        <div class="row align-items-center">
          <div
            class="col-md-12 aos aos-init aos-animate text-center"
            data-aos="fade-up"
          >
            <h2>Our Partners</h2>
            <p>Lorem Ipsum is simply dummy text of the printing</p>
          </div>
        </div>
      </div>
      <Carousel
        :autoplay="3000"
        :loop="true"
        :wrap-around="true"
        :settings="settings"
        :breakpoints="breakpoints"
      >
        <Slide
          class="partnerslist d-flex"
          v-for="item in IndexPartners"
          :key="item.id"
        >
          <li class="carousel__item item">
            <a href="javascript:void(0);">
              <img
                class="img-fluid"
                :src="require(`@/assets/img/partners/${item.img}`)"
                alt="partners"
              />
            </a>
          </li>
        </Slide>
        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </div>
  <!-- /Partners  Section -->

  <!-- Popular Section -->
  <section
    class="vaciencies-section vaciencies-eight popular-section popular-eight"
  >
    <div class="container">
      <div class="section-heading heading-eight">
        <div class="row align-items-center">
          <div
            class="col-md-12 aos aos-init aos-animate text-center"
            data-aos="fade-up"
          >
            <h2>Most Popular Jobs</h2>
            <p>Highlight the most popular owners</p>
          </div>
        </div>
      </div>
      <div class="vacancies-details">
        <div class="row">
          <div
            class="col-xl-4 col-lg-6 col-md-6 col-sm-12 aos"
            data-aos="fade-up"
          >
            <div class="vacancies-box">
              <div class="vacancies-top">
                <span class="topic">Marketing</span>
                <a href="javascript:void(0);" class="fav-icon-top">
                  <i class="fa-regular fa-bookmark"></i>
                </a>
              </div>
              <div class="vacancies-inner">
                <div class="vaca-img">
                  <img
                    src="@/assets/img/icons/job-logomark-1.png"
                    class="img-fluid"
                    alt="arrow"
                  />
                </div>
                <div class="vacancies-content">
                  <h4>
                    <router-link to="categories">Digital Marketer</router-link>
                  </h4>
                  <div class="vaca-location">
                    <p class="light-color">Company Name</p>
                    <p>
                      <i class="fas fa-light fa-location-dot"></i>San Diego, CA
                    </p>
                  </div>
                </div>
              </div>
              <div class="vaca-details">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod dolore magna aliqua.
                </p>
              </div>
              <div class="vaca-footer">
                <div class="time">
                  <p>
                    <i class="feather-briefcase"></i>Full Time
                    <span class="p-rate">$20k - $25k</span>
                  </p>
                </div>
                <div class="footer-btn">
                  <router-link to="categories" class="btn-view"
                    >Apply Now</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-xl-4 col-lg-6 col-md-6 col-sm-12 aos"
            data-aos="fade-up"
          >
            <div class="vacancies-box">
              <div class="vacancies-top">
                <span class="topic">Support</span>
                <a href="javascript:void(0);" class="fav-icon-top">
                  <i class="fa-regular fa-bookmark"></i>
                </a>
              </div>
              <div class="vacancies-inner">
                <div class="vaca-img">
                  <img
                    src="@/assets/img/icons/job-logomark-2.png"
                    class="img-fluid"
                    alt="arrow"
                  />
                </div>
                <div class="vacancies-content">
                  <h4>
                    <router-link to="categories"
                      >IT Support Associate</router-link
                    >
                  </h4>
                  <div class="vaca-location">
                    <p class="light-color">Company Name</p>
                    <p><i class="fas fa-light fa-location-dot"></i>New York</p>
                  </div>
                </div>
              </div>
              <div class="vaca-details">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod dolore magna aliqua.
                </p>
              </div>
              <div class="vaca-footer">
                <div class="time">
                  <p>
                    <i class="feather-briefcase"></i>Full Time
                    <span class="p-rate">
                      <i class="feather-dollar-sign"></i>$30k - $35k</span
                    >
                  </p>
                </div>
                <div class="footer-btn">
                  <router-link to="categories" class="btn-view"
                    >Apply Now</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-xl-4 col-lg-6 col-md-6 col-sm-12 aos"
            data-aos="fade-up"
          >
            <div class="vacancies-box">
              <div class="vacancies-top">
                <span class="topic">Support</span>
                <a href="javascript:void(0);" class="fav-icon-top">
                  <i class="fa-regular fa-bookmark"></i>
                </a>
              </div>
              <div class="vacancies-inner">
                <div class="vaca-img">
                  <img
                    src="@/assets/img/icons/job-logomark-3.png"
                    class="img-fluid"
                    alt="arrow"
                  />
                </div>
                <div class="vacancies-content">
                  <h4>
                    <router-link to="categories"
                      >Technical Support Engineer</router-link
                    >
                  </h4>
                  <div class="vaca-location">
                    <p class="light-color">Company Name</p>
                    <p>
                      <i class="fas fa-light fa-location-dot"></i>San Diego, CA
                    </p>
                  </div>
                </div>
              </div>
              <div class="vaca-details">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod dolore magna aliqua.
                </p>
              </div>
              <div class="vaca-footer">
                <div class="time">
                  <p>
                    <i class="feather-briefcase"></i>Full Time
                    <span class="p-rate">$40k - 425k</span>
                  </p>
                </div>
                <div class="footer-btn">
                  <router-link to="categories" class="btn-view"
                    >Apply Now</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-xl-4 col-lg-6 col-md-6 col-sm-12 aos"
            data-aos="fade-up"
          >
            <div class="vacancies-box">
              <div class="vacancies-top">
                <span class="topic">Sales</span>
                <a href="javascript:void(0);" class="fav-icon-top">
                  <i class="fa-regular fa-bookmark"></i>
                </a>
              </div>
              <div class="vacancies-inner">
                <div class="vaca-img">
                  <img
                    src="@/assets/img/icons/job-logomark-4.png"
                    class="img-fluid"
                    alt="arrow"
                  />
                </div>
                <div class="vacancies-content">
                  <h4>
                    <router-link to="categories"
                      >Product Sales Specialist</router-link
                    >
                  </h4>
                  <div class="vaca-location">
                    <p class="light-color">Company Name</p>
                    <p>
                      <i class="fas fa-light fa-location-dot"></i>Montreal,
                      Quebec
                    </p>
                  </div>
                </div>
              </div>
              <div class="vaca-details">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod dolore magna aliqua.
                </p>
              </div>
              <div class="vaca-footer">
                <div class="time">
                  <p>
                    <i class="feather-briefcase"></i>Full Time
                    <span class="p-rate">$35k - $65k</span>
                  </p>
                </div>
                <div class="footer-btn">
                  <router-link to="categories" class="btn-view"
                    >Apply Now</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-xl-4 col-lg-6 col-md-6 col-sm-12 aos"
            data-aos="fade-up"
          >
            <div class="vacancies-box">
              <div class="vacancies-top">
                <span class="topic">Account</span>
                <a href="javascript:void(0);" class="fav-icon-top">
                  <i class="fa-regular fa-bookmark"></i>
                </a>
              </div>
              <div class="vacancies-inner">
                <div class="vaca-img">
                  <img
                    src="@/assets/img/icons/Logomark-5.png"
                    class="img-fluid"
                    alt="arrow"
                  />
                </div>
                <div class="vacancies-content">
                  <h4>
                    <router-link to="categories"
                      >General Ledger Accountant</router-link
                    >
                  </h4>
                  <div class="vaca-location">
                    <p class="light-color">Company Name</p>
                    <p><i class="fas fa-light fa-location-dot"></i>Boston</p>
                  </div>
                </div>
              </div>
              <div class="vaca-details">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod dolore magna aliqua.
                </p>
              </div>
              <div class="vaca-footer">
                <div class="time">
                  <p>
                    <i class="feather-briefcase"></i>Full Time
                    <span class="p-rate">$40k - $55k</span>
                  </p>
                </div>
                <div class="footer-btn">
                  <router-link to="categories" class="btn-view"
                    >Apply Now</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-xl-4 col-lg-6 col-md-6 col-sm-12 aos"
            data-aos="fade-up"
          >
            <div class="vacancies-box">
              <div class="vacancies-top">
                <span class="topic">Design</span>
                <a href="javascript:void(0);" class="fav-icon-top">
                  <i class="fa-regular fa-bookmark"></i>
                </a>
              </div>
              <div class="vacancies-inner">
                <div class="vaca-img">
                  <img
                    src="@/assets/img/icons/job-logomark-6.png"
                    class="img-fluid"
                    alt="arrow"
                  />
                </div>
                <div class="vacancies-content">
                  <h4>
                    <router-link to="categories"
                      >Junior Graphic Designer</router-link
                    >
                  </h4>
                  <div class="vaca-location">
                    <p class="light-color">Company Name</p>
                    <p>
                      <i class="fas fa-light fa-location-dot"></i>California
                    </p>
                  </div>
                </div>
              </div>
              <div class="vaca-details">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod dolore magna aliqua.
                </p>
              </div>
              <div class="vaca-footer">
                <div class="time">
                  <p>
                    <i class="feather-briefcase"></i>Full Time
                    <span class="p-rate">$10k - $25k</span>
                  </p>
                </div>
                <div class="footer-btn">
                  <router-link to="categories" class="btn-view"
                    >Apply Now</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="align-items-center justify-content-center d-flex aos"
          data-aos="fade-up"
        >
          <router-link to="categories" class="category-btn"
            >View All Category</router-link
          >
        </div>
      </div>

      <div class="pop-bg-one">
        <img src="@/assets/img/popular-bg-1.png" alt="no-img" />
      </div>
      <div class="pop-bg-two">
        <img src="@/assets/img/popular-bg-2.png" alt="no-img" />
      </div>
    </div>
  </section>
  <!-- /Popular Section -->
</template>
<script>
import { Carousel, Slide, Navigation } from "vue3-carousel";
import IndexPartners from "@/assets/json/indexPartners.json";
import "vue3-carousel/dist/carousel.css";

export default {
  data() {
    return {
      IndexPartners: IndexPartners,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },

      breakpoints: {
        575: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 700px and up
        700: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 6,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
};
</script>
